<div class="award" (click)="navigateToBlogPost()">
  <rx-icon name="award" size="md" stroke="greyDark" fill="grey-dark" />
  <span class="award__text f-size-xs mt-1">Award winner</span>
</div>
